import styled from 'styled-components';

export const CabDetail = styled.div`
  background-color: #fff;
  border-radius: 16px;
  padding: 16px 12px;
`;

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ListItem = styled.span`
  font-size: 12px;
  line-height: 14px;
  color: #4a4a4a;
  font-weight: 400;
  font-family: 'Rubik';
  display: inline-flex;
  align-items: center;
`;

export const BorderRight = styled.span`
  width: 1px;
  height: 14px;
  display: inline-flex;
  margin: 0px 4px;
  background-color: #d8d8d8;
`;

export const IconWrapper = styled.span`
  justify-content: center;
  align-items: center;
  display: flex;
  height: 26px;
  width: 52px;
  border-radius: 32px;
  padding: 4px 8px;
  background-color: #fff;
  filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.20));
`;

export const QuickRideIcon = styled.img`
  height: 24px;
  padding: 4px;
  object-fit: contain;
`;

export const GifSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0px;
  border-bottom: 1px solid #d8d8d8;
`;

export const RunningCar = styled.img`
  height: 134px;
  width: 131px;
`;

export const RunningCarText = styled.span`
  font-size: 14px;
  line-height: 16px;
  font-weight: 700;
  margin-top: -16px;
  font-family: 'Rubik';
`;

export const BookingDetailsTransition = styled.div`
  transition: 0.5s ease-in-out;
`;